import { Helmet } from "react-helmet-async";
import {
  BRAND_NAME,
  LEGAL_NAME,
  LOGO_IMAGE,
  SITE_URL,
  SOCIAL_IMAGE,
  absoluteUrl,
} from "../seo/siteData";

function PageSeo({
  title,
  description,
  path = "/",
  keywords,
  image = SOCIAL_IMAGE,
  type = "website",
  structuredData = [],
}) {
  const canonical = absoluteUrl(path);
  const pageTitle = title ? `${title} | ${BRAND_NAME}` : `${BRAND_NAME} | ${LEGAL_NAME}`;
  const robots = "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1";

  return (
    <Helmet prioritizeSeoTags>
      <html lang="en-IN" />
      <title>{pageTitle}</title>
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hrefLang="en-IN" href={canonical} />
      <meta name="description" content={description} />
      <meta name="author" content={LEGAL_NAME} />
      <meta name="publisher" content={LEGAL_NAME} />
      <meta name="robots" content={robots} />
      <meta name="theme-color" content="#f7c600" />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <meta property="og:locale" content="en_IN" />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={BRAND_NAME} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={`${BRAND_NAME} logo and local delivery branding`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="application-name" content={BRAND_NAME} />
      <meta name="apple-mobile-web-app-title" content={BRAND_NAME} />
      <meta name="format-detection" content="telephone=yes" />
      <meta name="msapplication-TileColor" content="#f7c600" />
      <meta property="business:contact_data:website" content={SITE_URL} />
      <meta property="og:image:secure_url" content={image} />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:width" content="512" />
      <meta property="og:image:height" content="512" />
      <meta property="og:logo" content={LOGO_IMAGE} />
      {structuredData.map((item, index) => (
        <script key={`${canonical}-jsonld-${index}`} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
}

export default PageSeo;
